import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
} from '@/modules/Dictionary/__form/item';
import FInput from '@/plugins/form/FInput';

export default class DictionaryShipForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'Ship';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)({
      length: 100,
      lat: false,
    });
    setItemCode.bind(this)();
    this.setItemCategory();
    this.setItemAddress();
  }

  setItemCategory() {
    this.category = new FInput({
      name: 'Category',
      label: 'Категория судна',
    });
    this.category.setValidatorMax(50);
    this.setItem('category', this.category);
  }

  setItemAddress() {
    this.address = new FInput({
      name: 'Address',
      label: 'Адрес (порт приписки)',
    });
    this.address.setValidatorMax(100);
    this.setItem('address', this.address);
  }
}
